function SignIn() {
    return ( <h1>SignIn</h1> );
}

export default SignIn;